import { useEffect, useMemo, useState } from 'react'
import {
  defaultHomeHeroSettings,
  subscribeHomeHeroSettings,
  type HomeHeroSettings,
} from '../data/homeHeroSettings'

export function useHomeHeroSettings() {
  const [settings, setSettings] = useState<HomeHeroSettings>(defaultHomeHeroSettings)

  useEffect(() => subscribeHomeHeroSettings(setSettings), [])

  const activeSlides = useMemo(
    () =>
      settings.slides
        .filter((slide) => slide.enabled)
        .sort((first, second) => first.order - second.order),
    [settings.slides],
  )

  return { settings, activeSlides }
}
